export default __webpack_public_path__ + "static/media/doc-home.615b75cd.svg";